import React, { useCallback, useState } from "react";
import { cn } from "../../utils/cn";
import PdfPageViewer from "../../pages/contract-dashboard/components/signature-field-editor/PdfPageViewer";

/**
 * PDF stage matching the signature editor / preview pane.
 * Tracks pageDimensions so SignatureBox overlays can render.
 */
const TourPdfStage = ({
  pdfBlob,
  loadingPdf,
  loadError,
  fields = [],
  selectedSignerId = null,
  viewOnly = false,
  className,
  framed = true,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
}) => {
  const [pageDimensions, setPageDimensions] = useState({});
  const [page, setPage] = useState(currentPage);

  const handlePageDimensions = useCallback((pageNumber, widthPt, heightPt) => {
    setPageDimensions((prev) => ({
      ...prev,
      [pageNumber]: { widthPt, heightPt },
    }));
  }, []);

  const handlePageChange = (next) => {
    setPage(next);
    onPageChange?.(next);
  };

  // Keep in sync when parent forces a page (e.g. signature scene → page 3)
  React.useEffect(() => {
    setPage(currentPage);
  }, [currentPage]);

  return (
    <div
      className={cn(
        "pointer-events-auto flex min-h-0 flex-1 flex-col overflow-hidden bg-muted/20",
        framed &&
          "h-[min(70dvh,44rem)] min-h-[24rem] w-full rounded-lg border border-border",
        !framed && "h-full w-full",
        className
      )}
    >
      <div className="flex h-full min-h-0 flex-1 flex-col [&_>div]:h-full [&_>div]:min-h-0">
        <PdfPageViewer
          open
          pdfBlob={pdfBlob}
          fields={fields}
          selectedSignerId={selectedSignerId}
          currentPage={page}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onSelectField={() => {}}
          onUpdateFieldGeometry={() => {}}
          onAddField={() => {}}
          loadingPdf={loadingPdf}
          loadError={loadError}
          canAddField={!viewOnly}
          viewOnly={viewOnly}
          pageDimensions={pageDimensions}
          onPageDimensions={handlePageDimensions}
        />
      </div>
    </div>
  );
};

export default TourPdfStage;
